import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TableService, VisitedService} from "@amlCore/services";
import { TableReactiveUrlController } from "@amlCore/tableReactive";
import {DetectTransaction} from "../../../models/detectTransaction.model";
import {SettingsTransactionsService} from "../settingsTransactions.service";

@Component({
  selector: "app-detect-transactions",
  templateUrl: "./detectTransactions.component.html",
  styleUrls: ['./detectTransactions.component.scss']
})

export class DetectTransactionsComponent extends TableReactiveUrlController implements OnInit, OnDestroy {
  isShowVisited = true;
  detectTransactionsList: DetectTransaction[] = []; // сценарии выявления операций обязательного контроля

  constructor(protected activatedRoute: ActivatedRoute,
              protected router: Router,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              private service: SettingsTransactionsService) {
    super(router, activatedRoute, visitedService, tableService, {sort: 'scName', dir: 'ASC'});
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((data) => {
      this._loadList(this.syncParams(data));
    });
  }

  onPageChange(params): void {
    this.navigate(this.getParams(params));
  }

  onSearch(): void {
    const params = this.getSearchPage(this.filter);
    this.onPageChange(params);
  }

  private _loadList(params?: any): void {
    const queryParams = this.getParams(params);
    this.service.getDetectTransactions(queryParams).subscribe((data) => {
      this.isSelectedAll = false;
      this.detectTransactionsList = data.content;
      this.total = data.totalElements;
      this.scrollRun();
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  getFilterObject(data): object {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  // @overide метод кастомной обработки плоского объекта фильтра
  // содержащего параметры запроса в виде объекта
  protected customPatchPlanObject(result, filter, key): void {
    // обработка случая для справочника валют
    if (key === 'currency' && filter[key]) {
      result[key] = filter[key].code;
    }
  }

  /**
   * Метод открытия формы сценария
   * id - уникальный идентификатор сценария
   */
  viewForm(id: string): void {
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(["detectTransactionForm", id]);
  }

  ngOnDestroy(): void {
    this.checkScrollOptions();
  }
}
